import { Button, Menu, MenuItem, Popover ,Icon} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import React, { SyntheticEvent } from "react";

import Heading from "common/fragments/Heading";
import Padding from "common/fragments/Padding";
import Label from "core/components/label/Label";
import Topic from "../../entity/Topic";
import TopcicSubscriptionForm from "./TopicSubscriptionForm";
import UserSubscriptionForm from "./UserSubscriptionForm";

enum Mode { CLOSED, SELECT, FORM_TOPIC, FORM_USER }

interface ISubscriptionsPopoverState {
	mode: Mode,
	followedUser: boolean,
	followedTopic: boolean
}
export class SubscriptionsPopover extends React.Component<{topic: Topic}, ISubscriptionsPopoverState> {

	constructor(props) {
		super(props);
		let {followedUser,followedTopic} = this.props.topic;
		this.state = {mode: Mode.CLOSED,followedUser,followedTopic};
	}

	public render() {
		const {topic} = this.props;

		let content;

		switch (this.state.mode) {

			case Mode.FORM_TOPIC:
				content = (
					<Padding.Base>
						<Heading.H3 k="topicSubscription.form">Subscribe to this Discussion</Heading.H3>
						<div className="subscriptions-popover-form">
							<TopcicSubscriptionForm topicId={topic.id} onAfterSave={(ts) => {
								this.setState({mode: Mode.CLOSED,followedTopic:this.isFollwed(ts)});
							}} />
						</div>
					</Padding.Base>
				);
				break;

			case Mode.FORM_USER:
				content = (
					<Padding.Base>
						<Heading.H3 k="userSubscription.form">Follow {topic.createdBy.firstName + " " + topic.createdBy.lastName}</Heading.H3>
						<div className="subscriptions-popover-form">
							<UserSubscriptionForm targetUserId={topic.createdBy.id} onAfterSave={(us) => {
								this.setState({mode: Mode.CLOSED,followedUser:this.isFollwed(us)});
							}} />
						</div>
					</Padding.Base>
				);
				break;

			default:
				content = (
					<Menu>
						{this.state.followedTopic && (<Icon icon={IconNames.TICK} style={{float:"left",padding:"5px"}}/>)}
						<MenuItem text={<Label k="subscribe.topc" v="This Conversation" />} onClick={() => {
							this.setState({mode: Mode.FORM_TOPIC});							
						}}/>
						{this.state.followedUser && (<Icon icon={IconNames.TICK} style={{float:"left",padding:"5px"}}/>)}
						<MenuItem text={<Label k="subscribe.user" v="This User" />} onClick={() => {
							this.setState({mode: Mode.FORM_USER});
						}}/>
					</Menu>
				);
				break;
		}

		return (
			<Popover
				onInteraction={this.handleInteraction}
				isOpen={Mode.CLOSED !== this.state.mode}
				content={content}
			>
				<Button icon={IconNames.CARET_DOWN} onClick={() => this.setState({mode: Mode.SELECT})}>
					{this.state.followedTopic || this.state.followedUser?(<Label k="topic.followed" v="Followed" />):(<Label k="topic.follow" v="Follow" />)}
				</Button>
			</Popover>
		);
	}

	@autobind
	private handleInteraction(nextOpenState: boolean, e:SyntheticEvent<HTMLElement>) {
		if((Mode.SELECT !== this.state.mode && !nextOpenState) || (e !== undefined && e.type !== "click")) {
			this.setState({mode: Mode.CLOSED});
		}
	}

	@autobind
    private isFollwed(ts: {instant:boolean;emailNotification:boolean;digest:string | String;}){
        return ts && ((ts.instant && ts.emailNotification) || (ts.emailNotification && (ts.digest == "daily" || ts.digest == "weekly")));
    }
}




// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/SubscriptionsPopover.tsx